<template lang="jade">
  div
    .row(v-if="!editingSheet")
      .col-md-6.col-md-offset-3.center-element
        h1 Carregando
    .row(v-if="editingSheet")
      div(:class="classSheetView")
        loading(v-if="seendingSheet")
        .col-md-12(:style="setHeight", v-on:scroll="scrolling($event)", ref="sheet")
          .well
            modal(name="keys-info", :height="700", :width="880", :scrollable="true", :adaptive="true")
              .col-md-12.center-element
                img(src="static/images/helperKeys.png", style="width: 90%;")
              .col-md-12.center-element(style="padding: 0px; bottom: 0px; position: absolute;")
                button.close-modal(v-on:click="closeModal()") Fechar

            .row.mb20(v-if="queueSheets.total > 1")
              .col-md-3
                label
                  input(type="checkbox", v-model="showPdfCookie")
                  | &nbsp; Mostrar PDF
              .col-md-1.pull-right.center-element
                a(v-on:click="openModalInfoKeys()")
                  span.glyphicon.glyphicon-question-sign
              .col-md-2.pull-right.center-element
                h4 {{ queueSheets.actual + 1 }} de {{ queueSheets.total }}
              .col-md-6.pull-right.center-element
                h4 {{ sheetInfo.employee }} - {{ sheetInfo.start_date | isoDate }}
            .row.mb20(v-if="queueSheets.total <= 1")
              .col-md-3
                label
                  input(type="checkbox", v-model="showPdfCookie")
                  | &nbsp; Mostrar PDF
              .col-md-8.center-element
                h4 {{ sheetInfo.employee }} - {{ sheetInfo.start_date | isoDate }}
              .col-md-1.center-element
                a(v-on:click="openModalInfoKeys()")
                  span.glyphicon.glyphicon-question-sign
            hr
            sheet
            hr
            .row.mb40(v-if="canEditCurrentSheet" style="display: flex; align-items: center;")
              .col-md-2.col-sm-2
                button.bnt.btn3d.btn-info.btn-sm(@click="tempNextSheet") Próxima folha

              .col-md-2.col-sm-2.col-sm-offset-1
                button.bnt.btn3d.btn-warning.btn-sm.pull-right(v-on:click="reprocessSheet()", :disabled="hasAnyPendingSeending || seendingSheet") Reprocessar
                  br
                  | Folha
              .col-md-2.col-sm-2
                button.bnt.btn3d.btn-danger.btn-sm(v-on:click="ignoreSheet()", :disabled="hasAnyPendingSeending || seendingSheet") Ignorar
                  br
                  | Folha

              .col-md-6.col-sm-5.center-element
                button.bnt.btn3d.btn-success.btn-lg(v-on:click="sendSheet()", :disabled="hasAnyPendingSeending || seendingSheet" style="margin-bottom: 5px") Aprovar

      .col-md-5.pdf(:style="setHeight", ref="imagepdf", v-if="showPdf")
        //pdf-view(:setHeight="setHeight", ref="pdf")
        img(:src="sheetInfo.imageUrl", :style="imageBlockStyle")

</template>
<script>
import swal from 'sweetalert2'
import Sheet from './Sheet/Sheet.vue'
import PdfView from './common/PdfView.vue'
import Loading from './common/Loading.vue'
import { handleRequest } from '../services'
import Cookies from 'js-cookie'

export default {
  components: {
    Sheet,
    PdfView,
    Loading
  },
  created () {
    this.showPdf = ['true', true].includes(Cookies.get('showPdf'))
    this.loadSheet()
  },
  data () {
    return {
      showPdf: false
    }
  },
  props: ['uuid'],
  computed: {
    showPdfCookie: {
      get () { return this.showPdf },
      set (value) {
        Cookies.set('showPdf', value)
        this.showPdf = value
      }
    },
    classSheetView () {
      return {
        'col-md-5': this.showPdf,
        'col-md-offset-1': this.showPdf,
        'col-md-6': !this.showPdf,
        'col-md-offset-3': !this.showPdf
      }
    },
    selectedEmployee () {
      return this.$store.getters.employeesSheetVerifySelected.items[0]
    },
    editingSheet () {
      return this.$store.getters.editingSheet
    },
    sheetInfo () {
      return this.$store.getters.currentSheetInfo
    },
    hasAnyPendingSeending () {
      return this.$store.getters.hasAnyPendingSeending
    },
    seendingSheet () {
      return this.$store.getters.seendingSheet
    },
    setHeight () {
      return {
        height: (window.innerHeight - 120) + 'px',
        overflow: 'scroll'
      }
    },
    imageBlockStyle () {
      return {
        width: '100%'
      }
    },
    canEditCurrentSheet () {
      return this.$store.getters.canEditCurrentSheet
    },
    queueSheets () {
      return this.$store.getters.queueSheets
    }
  },
  methods: {
    tempNextSheet () {
      this.$store.dispatch('nextSheet')
    },
    loadSheet () {
      this.$store.dispatch('editing', false)
      this.$store.dispatch('startVerify', {
        uuid: this.uuid
      })
    },
    sendSheet () {
      swal({
        title: 'Você tem certeza?',
        text: 'Os pontos serão criados a partir desses dados, portanto não será possivel voltar atrás!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Voltar'
      }).then(() => {
        this.$store.dispatch('sendSheet')
      })
    },
    ignoreSheet () {
      swal({
        title: 'Você tem certeza?',
        text: 'Você não poderá alterar essa folha novamente!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Voltar'
      }).then(() => {
        this.$store.dispatch('ignoreSheet')
      })
    },
    scrolling (e) {
      const sheet = e.target
      const pdf = this.$refs.imagepdf

      const scroll = {
        sheet: { current: sheet.scrollTop, max: sheet.scrollHeight - sheet.clientHeight },
        pdf: { current: pdf.scrollTop, max: pdf.scrollHeight - pdf.clientHeight }
      }
      const percent = scroll.sheet.current / scroll.sheet.max
      pdf.scrollTop = percent * scroll.pdf.max
    },
    openModalInfoKeys () {
      this.$modal.show('keys-info')
    },
    reprocessSheet () {
      const params = {
        kind: 'all',
        sheet_uuids: [this.uuid]
      }

      handleRequest.apiPost('reprocess-sheet-digits', params)
        .then(response => {
          swal({
            title: response.data.success,
            type: 'success'
          })
          this.$store.dispatch('nextSheet')
        })
        .catch(error => {
          swal({
            title: 'Aconteceu um erro',
            text: error.data || 'Por favor, tente novamente',
            type: 'error'
          })
        })
    },
    closeModal () {
      this.$modal.hide('keys-info')
    }
  },
  filters: {
    isoDate (date) {
      let result = new Date(Date.parse(date))

      const day = result.getDate() + 1
      const month = result.getMonth() + 1
      const year = result.getFullYear()

      return (day < 10 ? ('0' + day) : day) + '/' + (month < 10 ? ('0' + month) : month) + '/' + year
    }
  },
  updated () {
    if (!this.$store.getters.editingSheet) {
      this.loadSheet()
    }
    this.$store.dispatch('bottomOfSheet', this.$el.getBoundingClientRect().bottom)
  }
}
</script>

<style scoped>
  .pdf {
    right: 100px;
    position: fixed;
    overflow: scroll;
  }
  .well {
    margin: 0px;
  }

  .close-modal {
    width: 100%;
    height: 40px;
    border: none;
    background-color: #15A3B5;
    font-weight: bold;
    color: white;
  }

  .close-modal:hover {
    background-color: #15ABBD;
  }

  @media (min-width: 992px) {
    .col-md-offset-1-2 {
      margin-left: 13%;
    }
  }
</style>



// WEBPACK FOOTER //
// Checker.vue?04b61068